import moment from 'moment';
import { setFilterObject, setInitialParams,showSnackbarAction } from '../Redux/actions';
import Firebase from "firebase/app";
import { firestore, functions } from "../Firebase";
import axios from "axios";
import {url} from "./constants";
import axiosHandler from '../Services/axiosHandler';
import { googleAnalyticsTabClick, pushToGA } from '../Services/users';


export const getDateString = (timeStamp: any) => {
  if (timeStamp) {
    const utcDate = moment.utc(timeStamp.toDate());
    const localDate = moment(utcDate).local();
    return localDate.format('DD MMM YY, LT');
  } else {
    return '';
  }
};

export const getDateString3 = (date: any) => {
  let newDate = new Date(date);
  
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };

  const formattedDate = newDate.toLocaleString('en-US', options);

  return formattedDate;
};

export const formatCacheDate = (date: any) => {
  let newDate = new Date(date);
  
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: "numeric",
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  };

  const formattedDate = newDate.toLocaleString('en-US', options);

  return formattedDate;
};

export const getDateStringUpdated = (timeStamp: any) => {
  if (timeStamp) {
    const utcDate = moment.utc(timeStamp.toDate());
    const localDate = moment(utcDate).local();
    return localDate.format('DD-MMM-YY, LT');
  } else {
    return '';
  }
};

export const getDateString2 = (timeStamp: any) => {
  if (timeStamp) {
    const utcDate = moment.utc(timeStamp.toDate());
    const localDate = moment(utcDate).local();
    return localDate.format('DD MMM YYYY');
  } else {
    return '';
  }
};

export const getDateIsoString = (timeStamp: any) => {
  if (timeStamp) {
    const utcDate = moment.utc(timeStamp.toDate());
    const localDate = utcDate.toISOString().slice(0, 10);
    return localDate;
  } else {
    return '';
  }
};

// export const getExpirationDate = (date:any) => {
//   if(date){
//     let result = new Date(date);
//     result.setDate(result.getDate());
//     return result.toISOString().slice(0, 10);
//   }else{
//     return '';
//   }
// }

export const getExpirationDate = (date:any, days:any) => {
  // if(date && days){
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result.toISOString().slice(0, 10);
  // }else{
  //   return '';
  // }
}

export const getFormattedDate = (date:any) => {
    let newDate = new Date(date);
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
}

export const getFormattedDateForSubscription = (date:any) => {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  let newDate = new Date(date);
  const day = newDate.getDate();
  const month = monthNames[newDate.getMonth()];
  const year = newDate.getFullYear();
  const formattedDate = `${day} ${month} ${year}`;
  return formattedDate;
}

export const getFormattedDateUpdated = (date:any) => {
  if (date) {
    const utcDate = moment.utc(date);
    const localDate = moment(utcDate).local();
    return localDate.format('DD-MMM-YY, LT');
  } else {
    return '';
  }
}


export const addMonths = (timeStamp:any, months:any) => {
 if(timeStamp) {
  const utcDate = moment.utc(timeStamp.toDate());
  const localDate = moment(utcDate).local().format('DD MMM YYYY, LT');
  let result = new Date(localDate);
  // result.setDate(result.getDate() + days);
  // result.setMonth(result.getMonth()+months);
  return  Firebase.firestore.Timestamp.fromDate(
    new Date(result.setMonth(result.getMonth()+months))
  );
 }

//  var newDate = new Date(date.setMonth(date.getMonth()+8));
}

export const addMonthsWithoutTimestamp = (timeStamp:any, months:any) => {
  if(timeStamp) {
   const utcDate = moment.utc(timeStamp.toDate());
   const localDate = moment(utcDate).local().format('DD MMM YYYY, LT');
   let result = new Date(localDate);
   // result.setDate(result.getDate() + days);
   // result.setMonth(result.getMonth()+months);
  return  new Date(result.setMonth(result.getMonth()+months))
  }
 
 //  var newDate = new Date(date.setMonth(date.getMonth()+8));
 }

export const compareDates = (date1: any, date2: any) => {
  // console.log("current date",date1, "expiration date",date2);
  if(date1 > date2){
    return true
  }else{
    return false
  }
}

export const getFilterObject = (
  data: { [key: string]: any }[],
  dispatcher: any
) => {
  const finalData: { [key: string]: string[] } = {};
  data.forEach((item) => {
    Object.keys(item).forEach((key) => {
      let value = item[key];
      if (item[key]?.toDate) {
        value = getDateString(item[key]);
      } else if (key === 'user_first_name') {
        value = item[key] + ' ' + item['user_last_name'];
        key = 'Name';
      } else if (key === 'admin_first_name') {
        value = item[key] + ' ' + item['admin_last_name'];
        key = 'Admin Name';
      }

      if (finalData[key]) {
        if (!finalData[key].includes(value)) {
          finalData[key].push(value);
        }
      } else {
        finalData[key] = [value];
      }
    });
  });

  dispatcher(setFilterObject(finalData));
};

export const getFilterBranch = (data: { [key: string]: any }[]) => {
  const finalData: { [key: string]: string[] } = {};
  data.forEach((item) => {
    Object.keys(item).forEach((key) => {
      let value = item[key];
      if (item[key]?.toDate) {
        value = getDateString(item[key]);
      } else if (key === 'user_first_name') {
        value = item[key] + ' ' + item['user_last_name'];
        key = 'Name';
      } else if (key === 'admin_first_name') {
        value = item[key] + ' ' + item['admin_last_name'];
        key = 'Admin Name';
      }

      if (finalData[key]) {
        if (!finalData[key].includes(value)) {
          finalData[key].push(value);
        }
      } else {
        finalData[key] = [value];
      }
    });
  });

  return finalData;
};

export const getDateAndTime = (timeStamp: string, format: string) => {
  const utcDate = moment.utc(timeStamp);
  const localDate = moment(utcDate).local();
  return localDate.format(format);
};

export const searchUserItem = (itemList: any[], searchQuery: string) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    if (searchQuery.match(/^[0-9]+$/) != null) {
      data = data.filter((item) => item.contact_no.includes(searchQuery));
    } else {
      data = data.filter((item) =>
        String(item.user_first_name + item.user_last_name)
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }
  }
  return data;
};

export const searchAPIItem = (itemList: any[], searchQuery: string) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    data = data.filter((item) =>
      item.customer_name.toLowerCase().includes(searchQuery.toLowerCase()) || item.contact_no.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }
  return data;
};


export const searchColumnItem = (itemList: any[], searchQuery: string) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    if (searchQuery.match(/^[0-9]+$/) != null) {
    } else {
      data = data.filter((item) =>
        item.id.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
  }
  return data;
};

export const searchOrganizationItem = (
  itemList: any[],
  searchQuery: string
) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    if (searchQuery.match(/^[0-9]+$/) != null) {
      data = data.filter((item) => item.mobile_number.includes(searchQuery));
    } else {
      data = data.filter((item) =>
        item.organization_name && item.organization_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
  }
  return data;
};

export const searchContacts = (filterData: any[], searchedItem: string) => {
  let data = [...filterData];
  if (searchedItem.match(/^[0-9]+$/) != null) {
    data = data.filter((item) => item.contact_no.includes(searchedItem));
  } else {
    data = data.filter((item) =>
      item.customer_name.toLowerCase().includes(searchedItem.toLowerCase())
    );
  }
  return data;
};

export const searchCallLogs = (filterData: any[], searchedItem: string) => {
  let data = [...filterData];
  if (searchedItem.match(/^[0-9]+$/) != null) {
  } else {
    data = data.filter((item) =>
      item.created_by.toLowerCase().includes(searchedItem.toLowerCase())
    );
  }
  return data;
};

export const searchTaskItem = (itemList: any[], searchQuery: string) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    data = data.filter((item) =>
      item.customer_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }
  return data;
};

export const searchProjectItem = (itemList: any[], searchQuery: string) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    data = data.filter((item) =>
      item.project_name.toLowerCase().includes(searchQuery.toLowerCase()) || item.developer_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }
  return data;
};

export const filterStatus = (itemsList: any[], status: string) => {
  let data = [...itemsList];
  if (status !== 'ALL') {
    data = data.filter((item) => item.status === status);
  }
  return data;
};

export const filterTaskStatus = (itemsList: any[], status: string) => {
  let data = [...itemsList];
  if (status !== 'ALL') {
    data = data.filter((item) => item.status === status);
  }
  return data;
};

export const filterProjectStatus = (itemsList: any[], status: string) => {
  let data = [...itemsList];
  if (status !== 'ALL') {
    data = data.filter((item) => item.property_type === status);
  }
  return data;
};

export const properFormat = (name: string) => {
  if (typeof name !== 'string') {
    return name;
  }
  if (name === 'CALLBACK') {
    return 'Call Back';
  }
  return name
    .split(' ')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};

export const sortAnalytics = (a: any, b: any) => {
  if (a.Total > b.Total) {
    return -1;
  } else {
    return 1;
  }
};
export const sortAnalyticsDownLoadReport = (a: any, b: any) => {
  if (a.total > b.total) {
    return -1;
  } else {
    return 1;
  }
};
export const sortUserAnalyticsChartReport = (a: any, b: any) => {
  if (a.total > b.total) {
    return -1;
  } else {
    return 1;
  }
};
export const sortUserAnalyticsTableReport = (a: any, b: any) => {
  if (a.Issued_Licenses > b.Issued_Licenses) {
    return -1;
  } else {
    return 1;
  }
};

export const chunk = (arr: any[], chunkSize: number) => {
  if (chunkSize <= 0) {
    return [];
  }
  var R = [];
  for (var i = 0, len = arr.length; i < len; i += chunkSize)
    R.push(arr.slice(i, i + chunkSize));
  return R;
};

export const timer = (ms: number) => {
  return new Promise((res) => setTimeout(res, ms));
};


// <div>Hello,</div> <br/><div>Your account will expire on DD||MM||YYYY.</div> <br/>  <div>Either you have been very busy, or missed our reminders to you! It is not too late yet. All you have to do is pay your renewal amount using the below link and allow us to renew your subscription for uninterrupted service and support.</div>  <br/><br/>   <a href=https://login1.read-pro.com/ style={background-color:#279EA0;color:#fff;padding:7px;border-radius:5px;font-weight: bold;margin-bottom:10px}>Renew Now*</a><br/><br/><div> (Only Applicable for desktop) </div> <br/> <div>Please note that your account will be automatically downgraded if the amount has not been paid on or before 2022-10-20.</div>

export const sendMail = async(mail?:any,mailId?:any,subject?:any) => {
  try{ 
  //   await firestore.collection("mail").add({
  //    to: mailId,
  //    message: {
  //      subject: subject,
  //      html:mail
  //    },
  //  })
  //  .then(() => {}
  //   // console.log("Queued email for delivery!")
  // );
}
  catch(err){
    //  console.log("error",err)
  }
};

export const getDateAndTimeString = (date: string, format: string) => {
  const localDate = moment(date).local();
  return localDate.format(format);
};
export const searchAPIItemAdmin = (itemList: any[], searchQuery: string) => {
  let data = [...itemList];
  if (searchQuery.length !== 0) {
    data = data.filter((item) =>
      item.source.toLowerCase().includes(searchQuery.toLowerCase()) || item.source.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }
  return data;
};

export const getDateFromISOString = (date:any) => {
  const dateObject = moment(date);
  const formattedDate = dateObject.format('D MMMM YYYY');
  return formattedDate;
}

export const getTimeFromISOString = (date:any) => {
  const dateObject = moment(date);
  const formattedTime = dateObject.format('h:mm A');
  return formattedTime;
}

export const convertSecondsToTime = (totalSeconds:any) => {

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  let timeFormat = '';

  if (hours > 0) {
    timeFormat += `${hours.toString().padStart(2, '0')}:`;
  }

  timeFormat += `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return timeFormat;
};

export const getGraceDateForPastApproval = (grace_past_days:any) => {
  let days = Number(grace_past_days)
  const graceDateForPastApproval = new Date();
  graceDateForPastApproval.setDate(graceDateForPastApproval.getDate() - days);
  return graceDateForPastApproval.toDateString()
}

export const convertToFilterString = (filterObject: { [key: string]: any }): string => {
  const filters: { [key: string]: any[] } = {};

  Object.keys(filterObject).forEach((val) => {
    if (filterObject && filterObject[val].length > 0) {
      filters[val] = filterObject[val];
    }
  });



  return JSON.stringify(filters);
};

export const uploadFileToS3 = async (file:any, Id:any) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('Id', Id);
    // formData.append('type', type);

    // console.log("leadId", leadId);
    // console.log("formData", formData);

    const response = await axiosHandler.post(url + '/s3Upload/dataUpload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data.url;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const openCustomMMBURL = (autoToken: string, page: string ) => {
  
  
  const updatedURL:any =autoToken.replace(/(bricks\/)[^?]*/, page);

  const [base, redirectPartRaw] = updatedURL.split("redirect_uri=");


  const encodedRedirectUri = encodeURIComponent(redirectPartRaw);

  const finalUrl = `${base}redirect_uri=${encodedRedirectUri}`;

  
  window.open(finalUrl, '_blank');
}

export const openCustomUrl = (autoToken: string, redirectUrl: string ) => {
  
  const [base, redirectPartRaw] = autoToken.split("redirect_uri=");

  const encodedRedirectUri = encodeURIComponent(redirectUrl);

  const finalUrl = `${base}redirect_uri=${encodedRedirectUri}`;

  
  return finalUrl
}

export const openCustomMMBURLWithGA = (autoToken: string, page: string , user:any,gaMsg:any ) => {
  
  // Extract base URL and replace the path after 'bricks/'
  const updatedURL = autoToken.replace(/(bricks\/)[^?]*/, page);
      googleAnalyticsTabClick(
        gaMsg,
        user
      );
  // Open the updated URL in a new tab
  window.open(updatedURL, '_blank');
}
export const uploadFileToS3Campaign = async (file:any, Id:any,isfetchHeader:any) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('Id', Id);
    formData.append('isfetchHeader', isfetchHeader);
    // formData.append('type', type);

    // console.log("leadId", leadId);
    // console.log("formData", formData);

    const response = await axiosHandler.post(url + '/s3Upload/dataUpload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error:any) {
    console.error('Error uploading file:', error.response.data.message);
    return error.response.data.message;
  }
};

export const getDateWithOffset = (date: string | Date, format: "onlyDate" | "dateAndTime" = "dateAndTime", offset?: boolean): string => {
  const dateObj = new Date(date);
// console.log("date",date)
  // UTC offset for IST (5 hours 30 minutes)
  let offsetInMilliseconds = 0;
  if(offset){
    offsetInMilliseconds = (5 * 60 + 30) * 60 * 1000;
  }
  const updatedDateObj = new Date(dateObj.getTime() + offsetInMilliseconds);

  // Formatting the date
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  const formattedDate = updatedDateObj.toLocaleDateString('en-US', options);

  if (format === "onlyDate") {
    return formattedDate; // Return only the date in the "Jan 03 2025" format
  }

  // Formatting the time
  const hours = String(updatedDateObj.getHours()).padStart(2, "0");
  const minutes = String(updatedDateObj.getMinutes()).padStart(2, "0");
  const timePeriod = updatedDateObj.getHours() >= 12 ? "PM" : "AM";
  const formattedTime = `${hours}:${minutes} ${timePeriod}`;

  // Returning the full formatted date and time
  return `${formattedDate}, ${formattedTime}`;
};

// export const showWhyReadproOrNot = (user: any, setShowWhyReadPro: any) => {
//   let isWhyReadproShown: any = localStorage.getItem("lastWhyReadproShowTime");
//   let today = new Date();
//   let todayDate = today.toISOString().split('T')[0]; // Get YYYY-MM-DD format

//   if (isWhyReadproShown) {
//     // Retrieve the last shown date from local storage
//     let parsedData = JSON.parse(isWhyReadproShown);
//     let isWhyReadproShownTime = new Date(parsedData.date);
//     let isWhyReadproShownDate = isWhyReadproShownTime.toISOString().split('T')[0];
//     // Check if the day has changed
//     if ((isWhyReadproShownDate !== todayDate) || (parsedData.user_email !== user.user_email)) {
//       // Update the last shown date in local storage
//       localStorage.setItem('lastWhyReadproShowTime', JSON.stringify({
//         user_email: user.user_email,
//         date: today
//       }));
//       setShowWhyReadPro(true) // Show the modal
//       pushToGA(
//         "event_tracking",
//         "read pro",
//         "read pro",
//         "full app banner impression",
//         user
//       )
//     }
//   } else {
//     setShowWhyReadPro(true);
//     pushToGA(
//       "event_tracking",
//       "read pro",
//       "read pro",
//       "full app banner impression",
//       user
//     )
//     localStorage.setItem("lastWhyReadproShowTime", JSON.stringify({
//       user_email: user.user_email,
//       date: today
//     }));
//   }
// }

const isValidJSON = (str:any) => {
  try {
      JSON.parse(str);
      return true; // Valid JSON
  } catch (e) {
      return false; // Invalid JSON
  }
}

export const showPopupOnPageLoad = (
  user: any,
  setShowWhyReadPro: any,
  organization: any,
  setShowAgentReverseFeedbackSlide: any,
  isUserUsingApp: any,
  hasActiveWAPackage: any,
  setShowWhatsappSlides: any,
  setShowFreeTrialWhatappComponentV2: any,
  setShowFreeTrialWhatappComponentV1: any,
  setShowFreeTrialModal: any,
  eligibleForWhatsappTrial: boolean,
  setShowAimcPopup: any,
  showAimcPopup: string
) => {
      // console.log("propss",showAimcPopup)
  let isWhyReadproShown: any = localStorage.getItem("lastWhyReadproShowTime");
  let feedbackSlideLastShown: any = localStorage.getItem("feedbackSlideLastShown");
  let lastBroadcastSlideShowTime: any = localStorage.getItem("lastBroadcastSlideShowTime");
  let today = new Date();
  const todayDay = new Date().getDay();
  let todayDate = today.toISOString().split("T")[0]; // Get YYYY-MM-DD format
  let anyPopupShown = false;
  // let didShowFeedbackSlide = false;
  // let didShowWhatsappSlide = false;

  if (user.profile === "Admin" && hasActiveWAPackage === false && eligibleForWhatsappTrial && user.user_oid) {
    if (lastBroadcastSlideShowTime && isValidJSON(lastBroadcastSlideShowTime)) {
      let parsedBroadcastSlideShowData = JSON.parse(lastBroadcastSlideShowTime);
      let lastBroadcastSlideShowDateAndTime = new Date(parsedBroadcastSlideShowData.date ? parsedBroadcastSlideShowData.date : "1999-12-12");
      let lastBroadcastSlideShowDate = lastBroadcastSlideShowDateAndTime.toISOString().split("T")[0];

      // Check if the slide was already shown today
      if (lastBroadcastSlideShowDate !== todayDate) {
        // if(hasActiveWAPackage === false){
        if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
            // console.log("todayDay22222",todayDay)
            setShowWhatsappSlides(false);
            // setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
            setShowFreeTrialModal(true); 
            // setShowFreeTrialWhatappComponentV2(false);
          } 
        setShowAgentReverseFeedbackSlide(false);
        setShowWhyReadPro(false);
        pushToGA(
          "event_tracking",
          "read pro",
          "read pro",
          "full app whatsapp banner impression",
          user
        );
        // didShowWhatsappSlide = true;
        // }
        // if (didShowWhatsappSlide) {
        anyPopupShown = true;
        localStorage.setItem(
          "lastBroadcastSlideShowTime",
          JSON.stringify({
            user_email: user.user_email,
            date: today
          })
        );
        // return;
        // }
      }
    } else {
      // if(hasActiveWAPackage === false){
      // setShowWhatsappSlides(true);
      if ([0, 1, 2, 3, 4, 5, 6].includes(todayDay)) {
        // console.log("todayDay22222",todayDay)
        setShowWhatsappSlides(false);
        // setShowFreeTrialWhatappComponentV1(false); // Tue, Sun
        setShowFreeTrialModal(true); 
        // setShowFreeTrialWhatappComponentV2(false);
      }
      setShowAgentReverseFeedbackSlide(false);
      setShowWhyReadPro(false);
      pushToGA(
        "event_tracking",
        "read pro",
        "read pro",
        "full app whatsapp banner impression",
        user
      );
      // didShowWhatsappSlide = true;
      // }
      // if (didShowWhatsappSlide) {
      anyPopupShown = true;
      localStorage.setItem(
        "lastBroadcastSlideShowTime",
        JSON.stringify({
          user_email: user.user_email,
          date: today
        })
      );
      // return;
      // }
      // return;
    }
  }

  if (anyPopupShown) {
    return;
  }

  // 🟢 NEW AIMC POPUP LOGIC STARTS HERE
  if (user.profile === "Admin" && user.user_oid && showAimcPopup === "Y") {
    let lastAimcPopupShown: any = localStorage.getItem("lastAimcPopupShown");

    let shouldShowAimcPopup = false;

    if (lastAimcPopupShown && isValidJSON(lastAimcPopupShown)) {
      let parsedAimcData = JSON.parse(lastAimcPopupShown);
      let lastShownDate = new Date(parsedAimcData.date).toISOString().split("T")[0];
      if (lastShownDate !== todayDate) {
        shouldShowAimcPopup = true; // not shown today
      }
    } else {
      shouldShowAimcPopup = true; // never shown before
    }

    // Example condition — adjust as needed
    if (shouldShowAimcPopup) {
      setShowAimcPopup(true);
      setShowWhyReadPro(false);
      setShowAgentReverseFeedbackSlide(false);
      setShowFreeTrialModal(false);
      setShowWhatsappSlides(false);

      // pushToGA(
      //   "event_tracking",
      //   "aimc",
      //   "aimc_trial_popup",
      //   "AIMC trial popup shown",
      //   user
      // );

      localStorage.setItem(
        "lastAimcPopupShown",
        JSON.stringify({ user_email: user.user_email, date: today })
      );

      anyPopupShown = true;
    }
  }
  // 🟢 NEW AIMC POPUP LOGIC ENDS HERE

  if (anyPopupShown) {
    return;
  }

  if (user.profile === "Admin" && user.user_oid) {
    let lastBroadcastSlideShowDateAndTime: Date | null = null;
    let timeDifferenceValid = true;

    if (lastBroadcastSlideShowTime) {

      let parsedBroadcastSlideShowData = JSON.parse(lastBroadcastSlideShowTime);
      lastBroadcastSlideShowDateAndTime = new Date(parsedBroadcastSlideShowData.date);

      // Ensure the last slide was shown today and check the time difference
      if (lastBroadcastSlideShowDateAndTime.toISOString().split("T")[0] === todayDate) {
        let timeDifference = (today.getTime() - lastBroadcastSlideShowDateAndTime.getTime()) / (1000 * 60 * 60); // Convert to hours
        timeDifferenceValid = timeDifference >= 2; // Only valid if 2 or more hours have passed
      }
    }
    if (timeDifferenceValid) {
      if (feedbackSlideLastShown && isValidJSON(feedbackSlideLastShown)) {
        let parsedSlideShowData = JSON.parse(feedbackSlideLastShown);
        let lastSlideShowTime = new Date(parsedSlideShowData.date ? parsedSlideShowData.date : "1999-12-12");
        let lastSlideShowDate = lastSlideShowTime.toISOString().split("T")[0];

        // Check if the slide was already shown today
        if (lastSlideShowDate !== todayDate) {
          if (
            organization.show_consent === "Y" &&
            (!organization.lead_reverse_feedback || organization.lead_reverse_feedback === "N")
          ) {
            setShowAgentReverseFeedbackSlide(true);
            setShowWhyReadPro(false);
            pushToGA(
              "event_tracking",
              "read pro",
              "read pro",
              "full app lqc banner impression",
              user
            );
            // didShowFeedbackSlide = true;
            anyPopupShown = true;
            localStorage.setItem(
              "feedbackSlideLastShown",
              JSON.stringify({ date: today })
            );
            // return;
          } else if (
            organization.show_consent === "N" &&
            organization.show_feedback_popup === "Y" &&
            (!organization.lead_reverse_feedback || organization.lead_reverse_feedback === "N")
          ) {
            setShowAgentReverseFeedbackSlide(true);
            setShowWhyReadPro(false);
            pushToGA(
              "event_tracking",
              "read pro",
              "read pro",
              "full app lqc banner impression",
              user
            );
            // didShowFeedbackSlide = true;
            anyPopupShown = true;
            localStorage.setItem(
              "feedbackSlideLastShown",
              JSON.stringify({ date: today })
            );
            // return;
          }
          // if (didShowFeedbackSlide) {

          // }
        }
      } else {
        if (
          organization.show_consent === "Y" &&
          (!organization.lead_reverse_feedback || organization.lead_reverse_feedback === "N")
        ) {
          setShowAgentReverseFeedbackSlide(true);
          setShowWhyReadPro(false);
          pushToGA(
            "event_tracking",
            "read pro",
            "read pro",
            "full app lqc banner impression",
            user
          );
          // didShowFeedbackSlide = true;
          anyPopupShown = true;
          localStorage.setItem(
            "feedbackSlideLastShown",
            JSON.stringify({ date: today })
          );
        } else if (
          organization.show_consent === "N" &&
          organization.show_feedback_popup === "Y" &&
          (!organization.lead_reverse_feedback || organization.lead_reverse_feedback === "N")
        ) {
          setShowAgentReverseFeedbackSlide(true);
          setShowWhyReadPro(false);
          pushToGA(
            "event_tracking",
            "read pro",
            "read pro",
            "full app lqc banner impression",
            user
          );
          // didShowFeedbackSlide = true;
          anyPopupShown = true;
          localStorage.setItem(
            "feedbackSlideLastShown",
            JSON.stringify({ date: today })
          );
        }
        // return;
      }
    }
  }

  // Stop "WhyReadPro" popup if "feedbackSlide" is already shown
  if (anyPopupShown) {
    return;
  }

  if (user.user_email && isUserUsingApp === false) {
    let lastSlideShowTime: Date | null = null;
    let lastBroadcastSlideShowDateAndTime: Date | null = null;
    let timeDifferenceValid = true;
    let timeDifferenceWhatsapp = true;
    let timeDifferenceBroadcast = true;

    if (feedbackSlideLastShown) {

      let parsedSlideShowData = JSON.parse(feedbackSlideLastShown);
      lastSlideShowTime = new Date(parsedSlideShowData.date);

      // Ensure the last slide was shown today and check the time difference
      if (lastSlideShowTime.toISOString().split("T")[0] === todayDate) {
        let timeDifference = (today.getTime() - lastSlideShowTime.getTime()) / (1000 * 60 * 60); // Convert to hours
        timeDifferenceWhatsapp = timeDifference >= 2; // Only valid if 2 or more hours have passed
      }
    }

    if (lastBroadcastSlideShowTime) {

      let parsedBroadcastSlideShowData = JSON.parse(lastBroadcastSlideShowTime);
      lastBroadcastSlideShowDateAndTime = new Date(parsedBroadcastSlideShowData.date);

      // Ensure the last slide was shown today and check the time difference
      if (lastBroadcastSlideShowDateAndTime.toISOString().split("T")[0] === todayDate) {
        let timeDifference = (today.getTime() - lastBroadcastSlideShowDateAndTime.getTime()) / (1000 * 60 * 60); // Convert to hours
        timeDifferenceBroadcast = timeDifference >= 2; // Only valid if 2 or more hours have passed
      }
    }
    if(timeDifferenceWhatsapp && timeDifferenceBroadcast){
      timeDifferenceValid = true;
    }else{
      timeDifferenceValid = false;
    }
    if (timeDifferenceValid) {
      if (isWhyReadproShown) {
        let parsedData = JSON.parse(isWhyReadproShown);
        let isWhyReadproShownTime = new Date(parsedData.date);
        let isWhyReadproShownDate = isWhyReadproShownTime.toISOString().split("T")[0];

        if (
          isWhyReadproShownDate !== todayDate ||
          parsedData.user_email !== user.user_email
        ) {
          localStorage.setItem(
            "lastWhyReadproShowTime",
            JSON.stringify({ user_email: user.user_email, date: today })
          );
          setShowWhyReadPro(true);
          pushToGA(
            "event_tracking",
            "read pro",
            "read pro",
            "full app banner impression",
            user
          );
        }
      } else {
        setShowWhyReadPro(true);
        pushToGA(
          "event_tracking",
          "read pro",
          "read pro",
          "full app banner impression",
          user
        );
        localStorage.setItem(
          "lastWhyReadproShowTime",
          JSON.stringify({ user_email: user.user_email, date: today })
        );
      }
    }
  }
};

// deviceCheck if it's mobile
export const deviceCheck = (): boolean => {
  const isMobile = {
    Android: function (): boolean {
      return navigator.userAgent.match(/Android/i) !== null;
    },
    BlackBerry: function (): boolean {
      return navigator.userAgent.match(/BlackBerry/i) !== null;
    },
    iOS: function (): boolean {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null;
    },
    Opera: function (): boolean {
      return navigator.userAgent.match(/Opera Mini/i) !== null;
    },
    Windows: function (): boolean {
      return navigator.userAgent.match(/IEMobile/i) !== null;
    },
    any: function (): boolean {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  return isMobile.any();
};

export const extractQueryParams = (dispatcher: any) => {
  const params = new URLSearchParams(window.location.search);
  const paramsObj = Object.fromEntries(params.entries());
  dispatcher(setInitialParams(paramsObj));
}

export const createBanner = async (data:any,history:any,dispatcher:any,appBannerScreen?:any) => {
  try {

    const response = await axiosHandler.post(url + '/bm/create', data);
    dispatcher(showSnackbarAction("Banner saved successfully!", "success"));
    if(appBannerScreen === true){
      history.replace("/banerManagement", { tabIndex: 1 })
    }
    else{
    history.replace("/banerManagement")
    }
    window.location.reload();
    return response.data
  } catch (error) {
    console.error('Error uploading file:', error);
    dispatcher(showSnackbarAction("error while creating the banner", "error"));
    if(appBannerScreen === true){
      history.replace("/banerManagement", { tabIndex: 1 })
    }
    else{
    history.replace("/banerManagement")
    }
    window.location.reload();
    throw error;
  }
};

export const fetchBanner = async (
  type:string,
  currentIndex:number,
  cRoute:any,
  tagObj:any
) => {
  try {

    const obj = {
      [type]: true
    };

    const response = await axiosHandler.post(url + '/bm/fetch',{page:cRoute,currentIndex:currentIndex,obj:obj,tagObj:tagObj});
    return response.data
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};


export const fetchAllBanner = async (
  setBannerData: (data: any[]) => void ,
  setCount: (data: any) => void,
  pageSize:any,
  page:any,
  setAppBanners: (data: any[]) => void ,
  setAppBannerCount: (data: any) => void,
) => {
  try {

    const pageU=parseInt(page)+1

    const response = await axiosHandler.get(url + '/bm/fetchAll',{params:{page:pageU,limit:pageSize}});
     if(response?.data){
      setBannerData(response?.data?.data?.webBanners || [])
      setCount(response?.data?.data?.webBannerCount || 0)
      setAppBanners(response?.data?.data?.appBanners || [])
      setAppBannerCount(response?.data?.data?.appBannerCount || 0)
     }
    // return response.data.data
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};


export const updateBanner = async (data:any,history:any,dispatcher:any,appBannerScreen?:any) => {
  try {

    const response = await axiosHandler.put(url + '/bm/update', data);
    dispatcher(showSnackbarAction("Banner saved successfully!", "success"));
    if(appBannerScreen === true){
      history.replace("/banerManagement", { tabIndex: 1 })
    }
    else{
    history.replace("/banerManagement")
    }
    window.location.reload();
    return response.data
  } catch (error) {
    console.error('Error uploading file:', error);
    dispatcher(showSnackbarAction("error while edit banner", "error"));
    if(appBannerScreen === true){
      history.replace("/banerManagement", { tabIndex: 1 })
    }
    else{
    history.replace("/banerManagement")
    }
    window.location.reload();
    throw error;
  }
};

export const deleteBanner = async (data:any,history:any,dispatcher:any,setShowDeleteIntegration:any) => {
  try {

    const response = await axiosHandler.put(url + '/bm/update', data);
    dispatcher(showSnackbarAction("Banner deleted successfully!", "success"));
    setShowDeleteIntegration(false)
    window.location.reload();
    return response.data
  } catch (error) {
    console.error('Error uploading file:', error);
    dispatcher(showSnackbarAction("error while deleting banner", "error"));
    window.location.reload();
    throw error;
  }
};

export const getDispositionList = (category: string, isTemplateAdmin: boolean) => {
  let dispositionList;
  if (category == "Utility") {
    dispositionList = ["Call Back", "Interested", "Not Interested", "Won", "Lost"]
  } else {
    dispositionList = ["My Templates"]
  }
  if (isTemplateAdmin && category != "Utility") {
    dispositionList = ["Pre Launch","Offers","Genric"]
  }
  return dispositionList;
}

export const getSubDispositionList = (disposition: string) => {
  let subDispositionList:any = [];
  if (disposition == "Call Back") {
    subDispositionList = ["Not Picked", "On Request", "Switched Off", "Not Reachable"]
  } else if (disposition == "Interested") {
    subDispositionList = ["Call Back", "Meeting", "Site Visit"]
  } else if (disposition == "Not Interested") {
    subDispositionList = ["Low Budget", "Location Mismatch", "DND"]
  } else if(disposition == "Won") {
    subDispositionList = ["Won"]
  } else if(disposition == "Lost") {
    subDispositionList = ["Better Deal/Already Purchased", "Loan Issue", "Financial Concern", "Plan Postponed"]
  }
  return subDispositionList;
}

export const tenPercent = (value: number | string): number | null => {
  const num = Number(value);
  return isNaN(num) ? null : Math.floor(num * 0.1);
};